import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { InstructorDetails } from '@udemy-v2/browse-course';
import styles from './instructor-card.module.scss';
import classNames from 'classnames';
import { InstructorStats } from '../instructor-stats/instructor-stats.react-component';
import { InstructorDescription } from '../instructor-description/instructor-description.react-component';
import { generateInstructorId } from '../utils/instructor-utils';
import { useInstructorCommunityBannerInfo } from '@/lib/hooks/use-instructor-community-banner-info';
import { InstructorCommunityBanner } from '../../instructor-community/instructor-community-banner';
import { useUserHasOrganization } from '@/lib/hooks/use-user-has-organization';
export interface InstructorCardProps {
  instructor: InstructorDetails;
  index: number;
}

/**
 * Renders an instructor card displaying the instructor's image, name, and title
 *
 * @example
 * ```jsx
 * <InstructorCard instructor={instructor} index={0} />
 * ```
 */
export const InstructorCard: React.FC<InstructorCardProps> = t0 => {
  const $ = _c(32);
  const {
    instructor,
    index
  } = t0;
  const {
    bannerInfo,
    hasCommunity
  } = useInstructorCommunityBannerInfo(instructor.id);
  const hasOrganization = useUserHasOrganization();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classNames(styles["instructor-card"], "ud-card");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== index) {
    t2 = generateInstructorId(index);
    $[1] = index;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <div id={t2} className={styles["instructor-anchor-offset"]} aria-hidden="true" />;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = instructor.url;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = classNames("ud-heading-lg ud-link-underline", styles["instructor-name"]);
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== instructor.name || $[7] !== instructor.url) {
    t6 = <a href={t4} className={t5}>{instructor.name}</a>;
    $[6] = instructor.name;
    $[7] = instructor.url;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== instructor.title) {
    t7 = instructor.title && <p className={classNames("ud-text-md", styles["instructor-title"])}>{instructor.title}</p>;
    $[9] = instructor.title;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t6 || $[12] !== t7) {
    t8 = <div className={styles["instructor-info"]}>{t6}{t7}</div>;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== hasCommunity || $[15] !== hasOrganization || $[16] !== instructor) {
    t9 = !hasOrganization && <InstructorStats instructor={instructor} showCommunityPoweredBadge={hasCommunity} />;
    $[14] = hasCommunity;
    $[15] = hasOrganization;
    $[16] = instructor;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== bannerInfo || $[19] !== hasCommunity || $[20] !== hasOrganization || $[21] !== instructor.name || $[22] !== instructor.url) {
    t10 = !hasOrganization && hasCommunity && bannerInfo && <InstructorCommunityBanner instructorName={instructor.name} instructorUrl={instructor.url} bannerInfo={bannerInfo} />;
    $[18] = bannerInfo;
    $[19] = hasCommunity;
    $[20] = hasOrganization;
    $[21] = instructor.name;
    $[22] = instructor.url;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== instructor.description) {
    t11 = instructor.description && <InstructorDescription description={instructor.description} />;
    $[24] = instructor.description;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t10 || $[27] !== t11 || $[28] !== t3 || $[29] !== t8 || $[30] !== t9) {
    t12 = <div className={t1}>{t3}{t8}{t9}{t10}{t11}</div>;
    $[26] = t10;
    $[27] = t11;
    $[28] = t3;
    $[29] = t8;
    $[30] = t9;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  return t12;
};